// The storefront used to render its own StorefrontHeader — a different wordmark,
// a different nav (Menu / How To Order / Find a Specialist / …) and different
// styling from the rest of the site, so /menu and /checkout looked like a
// separate product. It now uses the same SiteNav and SiteFooter as every other
// page; the cart drawer is passed in as onCartClick, which was the only real
// difference between the two headers.

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthActionsProvider, AuthStatusBanners } from 'components/auth/AuthActions';
import SiteNav from 'components/marketing/SiteNav';
import SiteFooter from 'components/marketing/SiteFooter';
import { COLORS, FONTS } from 'styles/theme';
import CartDrawer from './CartDrawer';
import 'styles/storefront-tokens.css';
import 'components/storefront/storefront.css';
import './flow.css';

export default function FlowLayout() {
  const [cartOpen, setCartOpen] = useState(false);

  return (
    <AuthActionsProvider>
      <div className="sf-flow" style={{ fontFamily: FONTS.sans, color: COLORS.dark, background: COLORS.cream }}>
        <SiteNav onCartClick={() => setCartOpen(true)} />
        <AuthStatusBanners />
        <main>
          <Outlet />
        </main>
        <SiteFooter />
        <CartDrawer open={cartOpen} onClose={() => setCartOpen(false)} />
      </div>
    </AuthActionsProvider>
  );
}
